module.exports = __webpack_public_path__ + "img/selected0-min.809f47c0.png";